import DOMPurify from 'dompurify';

// Explicit allowlist for editor-generated rich text. Anything outside
// this list (scripts, iframes, event handlers, inline styles, base/
// form/object/embed tags, javascript: URLs) is stripped by DOMPurify.
const SAFE_HTML_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'b', 'i', 'u', 'ul', 'ol', 'li',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'code', 'pre',
    'a', 'span', 'div', 'hr', 'sub', 'sup', 'small',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'title', 'class'],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'base', 'style'],
  FORBID_ATTR: ['onerror', 'onclick', 'onload', 'onmouseover', 'style'],
};

/**
 * Renders admin-authored rich text after sanitising with DOMPurify
 * against a strict allowlist (basic typography + lists + links).
 * Scripts, iframes, event handlers and inline styles are always
 * stripped — XSS-safe by construction.
 *
 * Returns null for empty/whitespace-only input so consumers can
 * cleanly skip the surrounding wrapper.
 */
export const SafeHtml = ({ html, className, ...rest }) => {
  if (!html || typeof html !== 'string' || !html.trim()) return null;
  const clean = DOMPurify.sanitize(html, SAFE_HTML_CONFIG);
  return (
    <div
      className={className}
      // SECURITY: input has just been sanitised against an explicit
      // allowlist; this is the single sanctioned site in the app
      // that may emit rendered HTML.
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: clean }}
      {...rest}
    />
  );
};

export default SafeHtml;
